export const UserSettingName = "customerEnvironment";
